<template>
  <div class="addplace-page container">
    <h1 class="title">Adicionar Lugar (Idioma: {{DefaultLanguage}})</h1>
    <div class="page-content">
      <steps
         :current="currentStep"
         type="pills"
         :show-footer="false"
      >
        <step title="Dados iniciais" description="Adicione os dados básicos deste Lugar">
          <place-form
            :onSubmit="addPlace"
            :is-disabled="isFormDisabled"
            :is-loading="isFormDisabled"
            button-label="Cadastrar e continuar"
          />
        </step>
        <step
          title="Imagens"
          description="Capa e outras imagens deste Lugar"
          v-if="!$route.params.placeId"
        >
          <image-upload
            accepttypes="image/*"
            :max="1000"
            @hasnoimages="withNoImages"
            @hasimages="withImages"
            fileSizeLimit="10MB"
            :on-submit="uploadImages"
            :on-set-cover="setCover"
            :on-set-legend="setLegend"
            :on-remove-item="removeImage"
            :images="PlaceImages"
            :enable-caption="false"
          />
        </step>
      </steps>
      <p class="has-text-centered">
        <router-link :to="`/${$route.params.lang}/places`" class="button is-link">Voltar para listagem de Lugares</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AsideMenuCtrlMixin from './AsideMenuCtrlMixin'
import ImageUploadMixin from '../forms/ImageUploadMixin'
import PlaceForm from '../forms/PlaceForm'
import ImageUpload from '../ImageUpload'
import { CreatePlace } from '../../api/place'
import { prepareFormData } from '../../helpers'

export default {
  name: 'AddPlacePage',
  mixins: [AsideMenuCtrlMixin, ImageUploadMixin],
  components: { PlaceForm, ImageUpload },
  data () {
    return {
      isFormDisabled: false,
      currentStep: 0
    }
  },
  computed: {
    ...mapGetters(['PlaceImages', 'DefaultLanguage'])
  },
  methods: {
    ...mapActions(['SetCurrentPlace']),
    addPlace (data) {
      this.isFormDisabled = true
      CreatePlace(prepareFormData({
        ...data,
        language: this.DefaultLanguage
      }))
        .then(
          success => {
            this.SetCurrentPlace(success.data)
            this.currentStep = 1
            this.isFormDisabled = false
          },
          error => {
            console.log(error.response)
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível criar o Lugar agora. Tente novamente.',
              duration: 10000
            })
            this.isFormDisabled = false
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/AddPlacePage.vue